import {ID, Response} from '../../../../../_metronic/helpers'
import {Paging} from '../../../../models/Response'
import {CriminalOffence} from '../../../criminalOffences/core/_model'
import {Reported, Reporter, ReportEvidence, Suspect} from '../../../judol/judol-list/core/_models'
import {IButtonPermission} from '../../../../models/IButtonPermission'

export type Judi = {
  id?: ID
  reportId?: number
  policeReportNo?: string
  policeReportDate?: string
  caseStatusId?: number
  crimeScene?: string
  crimeTime?: string
  chronology?: string
  caseStatusName?: string
  evidences: ReportEvidence[]
  criminalOffences: CriminalOffence[]
  modusOperandi: any[]
  reporteds: Reported[]
  reporters: Reporter[]
  suspects: Suspect[]
  amplifications?: any[]
  attentionLevel?: number
  isSubmit?: boolean
  reportDate?: string
  attentionDesc?: string
  statusName?: string
  button?: IButtonPermission
  satwilId?: number
  satwilName?: string
  createdAt?: string
  statusId?: number
  suspectRequired?: boolean
}

export type JudiQueryResponse = Response<Paging<Judi>>

export const initialJudi: Judi = {
  id: undefined,
  policeReportNo: '',
  policeReportDate: '',
  caseStatusId: 0,
  crimeScene: '',
  crimeTime: '',
  chronology: '',
  caseStatusName: '',
  criminalOffences: [],
  evidences: [],
  modusOperandi: [],
  reporteds: [],
  reporters: [],
  suspects: [],
  amplifications: [],
}
